/* eslint-disable */
import Button from '@material-ui/core/Button';

import Checkbox from '@material-ui/core/Checkbox';

import DeleteIcon from '@material-ui/icons/Delete';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import { makeStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';

import React, {useEffect} from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';

var timer = null;

const useStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    // float:'left'
    //display : 'flex'
  },
  tableRightBorder : { borderWidth: 1, borderColor: 'black', borderStyle: 'solid'},
  tableRightBorderHeader : { borderWidth: 1, borderColor: 'white', borderStyle: 'solid'} 
}));

export default function Thyroid(props) {
  const classes = useStyles();

  const [noduleList, setNoduleList] = React.useState(() => JSON.parse(JSON.stringify(props.noduleData)));
//   const [noduleClinic, setNoduleClinic] = React.useState(() => JSON.parse(window.localStorage.getItem("noduleClinic")));

//   const [noduleList, setNoduleList] = React.useState(() => JSON.parse(window.localStorage.getItem("nodule")));
  const [diameterValue, setDiameterValue] = React.useState(() => JSON.parse(JSON.stringify(props.noduleData.diameter[0]))); 
  const [diameterValue1, setDiameterValue1] = React.useState(() => JSON.parse(JSON.stringify(props.noduleData.diameter[1]))); 
  const [diameterValue2, setDiameterValue2] = React.useState(() => JSON.parse(JSON.stringify(props.noduleData.diameter[2]))); 
  const [maximalSizeValue, setMaximalSizeValue] = React.useState(() => JSON.parse(JSON.stringify(props.noduleData.diameter[3]))); 

  const [extrathyroidalGrossInput, setExtrathyroidalGrossInput] = React.useState(() => JSON.parse(JSON.stringify(props.noduleData.extrathyroidalGross.input))); 
  const [biopsyFnaDevice, setBiopsyFnaDevice] = React.useState(() => JSON.parse(JSON.stringify(props.noduleData.biopsy.FnaDevice))); 
  const [biopsyCnbSize, setBiopsyCnbSize] = React.useState(() => JSON.parse(JSON.stringify(props.noduleData.biopsy.CnbSize))); 
  const [complicationsOthersTxt, setComplicationsOthersTxt] = React.useState(() => JSON.parse(JSON.stringify(props.noduleData.complications.othersTxt))); 

  const [noduleRecommendation, setNoduleRecommendation] = React.useState(() => JSON.parse(JSON.stringify(props.noduleData.recommendation))); // 요청에 의해 현재 삭제됨
  const [saveComment, setSaveComment] = React.useState(() => JSON.parse(JSON.stringify(props.noduleData.comment))); // 컬럼
  const [saveNote, setSaveNote] = React.useState(() => JSON.parse(JSON.stringify(props.noduleData.note))); // 현재 컬럼명 Note -> Recommendation으로 변경
  const [diameterUnit, setDiameterUnit] = React.useState(''); 

  const noduleDefault = JSON.parse(window.localStorage.getItem("noduleDefault"));

  useEffect(() => {
      window.localStorage.setItem("nodule", JSON.stringify(noduleList));
      props.saveNodule(props.title, props.index, noduleList);
      props.uncheckNormal(props.noduleClinic.normalThy);
        //window.localStorage.setItem("noduleClinic", JSON.stringify(noduleClinic));
  }, [noduleList, noduleRecommendation, props.noduleClinic.normalThy]);


  function handleClickRadioCompos(targetVal, index) {
    if (targetVal === noduleList.composition) {
        var _noduleList = {...noduleList};
        _noduleList.composition = "";
        setNoduleList(_noduleList);    
    }
    /** recommendation - start **/
    var max_diameter = 0;
    var _noduleList = {...noduleList};

    if(_noduleList.diameter[5] === 'mm') max_diameter = _noduleList.diameter[3] * 0.1;
    else max_diameter = _noduleList.diameter[3];
    if(getRiskOfMalignancy(index) === '[K-TIRADS 5, High suspicion]' && max_diameter >= 1) setNoduleRecommendation('K-TIRADS 5,\nBiopsy recommendation');
    if(getRiskOfMalignancy(index) === '[K-TIRADS 4, Intermediate suspicion]' && max_diameter >= 1.5) setNoduleRecommendation('K-TIRADS 4,\nBiopsy recommendation');
    if(getRiskOfMalignancy(index) === '[K-TIRADS 3, Low suspicion]' && max_diameter >= 2) setNoduleRecommendation('K-TIRADS 3,\nBiopsy recommendation');
    if(getRiskOfMalignancy(index) === '[K-TIRADS 4, Intermediate suspicion]' && _noduleList.diffuseLesion) setNoduleRecommendation('K-TIRADS 4,\nCNB recommendation');
    /** recommendation - end **/
  }
  function handleClickRadioLocation(targetVal, index) {

    if (targetVal === noduleList.location.position) {
        var _noduleList = {...noduleList};
        _noduleList.location.position = "";
        _noduleList.location.type = "";
        setNoduleList(_noduleList);    }
}

  function handleClickRadioSpongi(targetVal, index) {

      if (targetVal === noduleList.spongiform) {
          var _noduleList = {...noduleList};
          _noduleList.spongiform = "";
          setNoduleList(_noduleList);    }
  }
  function handleClickRadioTail(targetVal, index) {

      if (targetVal === noduleList.cometTailArtifact) {
          var _noduleList = {...noduleList};
          _noduleList.cometTailArtifact = "";
          setNoduleList(_noduleList);    }
  }
  function handleClickRadioOri(targetVal, index) {
    var _noduleList = {...noduleList};
    if (targetVal === noduleList.orientation) {
        _noduleList.orientation = "";
        noduleList.orientation = "";
    }
    
    /** recommendation - start **/
    var max_diameter = 0;
    if(_noduleList.diameter[5] === 'mm') max_diameter = _noduleList.diameter[3] * 0.1;
    else max_diameter = _noduleList.diameter[3];
    if(getRiskOfMalignancy(0) === '[K-TIRADS 5, High suspicion]' && max_diameter >= 1) setNoduleRecommendation('K-TIRADS 5,\nBiopsy recommendation');
    if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && max_diameter >= 1.5) setNoduleRecommendation('K-TIRADS 4,\nBiopsy recommendation');
    if(getRiskOfMalignancy(0) === '[K-TIRADS 3, Low suspicion]' && max_diameter >= 2) setNoduleRecommendation('K-TIRADS 3,\nBiopsy recommendation');
    if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && _noduleList.diffuseLesion) setNoduleRecommendation('K-TIRADS 4,\nCNB recommendation');
    /** recommendation - end **/  
    console.log('click!', noduleList);
    setNoduleList(_noduleList);
  }

  function handleClickRadioMargin(targetVal, index) {
      if (targetVal === noduleList.margin) {
          var _noduleList = {...noduleList};
          _noduleList.margin = "";
          setNoduleList(_noduleList);    }
  }
  function handleClickRadioEcho(targetVal, index) {
    var _noduleList = {...noduleList};

    if (targetVal === noduleList.echogenicity) {
        _noduleList.echogenicity = ""; 
        noduleList.echogenicity = "";
        setNoduleList(_noduleList); 
    }
    /** recommendation - start **/
    var max_diameter = 0;
    if(_noduleList.diameter[5] === 'mm') max_diameter = _noduleList.diameter[3] * 0.1;
    else max_diameter = _noduleList.diameter[3];
    if(getRiskOfMalignancy(0) === '[K-TIRADS 5, High suspicion]' && max_diameter >= 1) setNoduleRecommendation('K-TIRADS 5,\nBiopsy recommendation');
    if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && max_diameter >= 1.5) setNoduleRecommendation('K-TIRADS 4,\nBiopsy recommendation');
    if(getRiskOfMalignancy(0) === '[K-TIRADS 3, Low suspicion]' && max_diameter >= 2) setNoduleRecommendation('K-TIRADS 3,\nBiopsy recommendation');
    if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && _noduleList.diffuseLesion) setNoduleRecommendation('K-TIRADS 4,\nCNB recommendation');
    /** recommendation - end **/
  }
  function handleClickRadioExtrathyroidal(targetVal, index) {
    if (targetVal === noduleList.extrathyroidal) {
        var _noduleList = {...noduleList};
        _noduleList.extrathyroidal = "";
        _noduleList.extrathyroidalLocation.ant = false;
        _noduleList.extrathyroidalLocation.post = false;
        _noduleList.extrathyroidalLocation.med = false;
        _noduleList.extrathyroidalLocation.lateral = false;
        setNoduleList(_noduleList);    
    }
}

function handleClickRadioExtrathyroidal2(targetVal, index) {
    if (targetVal === noduleList.extrathyroidal2) {
        var _noduleList = {...noduleList};
        _noduleList.extrathyroidal2 = "";
        _noduleList.extrathyroidalGross.trachea = false;
        _noduleList.extrathyroidalGross.RLN = false;
        _noduleList.extrathyroidalGross.others = false;
        _noduleList.extrathyroidalGross.input = '';
        setNoduleList(_noduleList);    
    }
}

  function handleClickRadioCalcification(targetVal, index) {
    if (targetVal === noduleList.calcification.entire) {
        var _noduleList = {...noduleList};
        _noduleList.calcification.entire = "";
        setNoduleList(_noduleList);    }
  }

  function handleClickRadioDiffuse(targetVal, index) {
    var _noduleList = {...noduleList};
    if (targetVal === noduleList.diffuseLesion) {
        _noduleList.diffuseLesion = "";
        noduleList.diffuseLesion = "";
        setNoduleList(_noduleList);    
    }
    /** recommendation - start **/
    var max_diameter = 0;
    if(_noduleList.diameter[5] === 'mm') max_diameter = _noduleList.diameter[3] * 0.1;
    else max_diameter = _noduleList.diameter[3];
    if(getRiskOfMalignancy(0) === '[K-TIRADS 5, High suspicion]' && max_diameter >= 1) setNoduleRecommendation('K-TIRADS 5,\nBiopsy recommendation');
    if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && max_diameter >= 1.5) setNoduleRecommendation('K-TIRADS 4,\nBiopsy recommendation');
    if(getRiskOfMalignancy(0) === '[K-TIRADS 3, Low suspicion]' && max_diameter >= 2) setNoduleRecommendation('K-TIRADS 3,\nBiopsy recommendation');
    if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && _noduleList.diffuseLesion) setNoduleRecommendation('K-TIRADS 4,\nCNB recommendation');
    /** recommendation - end **/
  }

  function handleClickRadioBiopsy(targetVal) {
    if (targetVal === noduleList.biopsy.type) {
        var _noduleList = {...noduleList};
        _noduleList.biopsy.type = "";
        if(targetVal === 'FNA') _noduleList.biopsy.FnaDevice = '';
        if(targetVal === 'CNB') _noduleList.biopsy.CnbSize = '';
        setNoduleList(_noduleList);    }
  }

  function handleClickRadioChangeInSize(targetVal) {
    if (targetVal === noduleList.changeInSize.value) {
        var _noduleList = {...noduleList};
        _noduleList.changeInSize.value = "";
        setNoduleList(_noduleList);    }
  }

  function A_i(){
    if(noduleList.calcification.micro === true
        || noduleList.orientation === 'Nonparallel'
        || noduleList.margin === 'Irregular (spiculated/microlobulated)')
        return true;
    return false;
}

  function checkHighsuspicion(){
    // console.log(noduleList);
    if(A_i() && noduleList.composition === 'Solid' && (noduleList.echogenicity === 'Mild hypo' || noduleList.echogenicity === 'Marked hypo' || noduleList.echogenicity === 'Hyper'))
        return true;
    return false;
}

function checkIntermediateSuspicion(){
    if(noduleList.composition === 'Solid' 
        && A_i()===false 
        && (noduleList.echogenicity === 'Mild hypo' || noduleList.echogenicity === 'Marked hypo'))
        return true;
    if((noduleList.composition === 'P.Cystic' || noduleList.composition === 'P.Solid')
        && A_i()===true)
        return true;
    if((noduleList.echogenicity === 'Iso' || noduleList.echogenicity === 'Hyper')
        && A_i()===true)
        return true;
    if(noduleList.diffuseLesion === 'extensive' || noduleList.diffuseLesion === 'infiltrative')
        return true;
        
    return false; 
}

function checkLowSuspicion(){
    if((noduleList.composition === 'P.Cystic' || noduleList.composition === 'P.Solid')
        && A_i()===false)
        return true;        
    if((noduleList.echogenicity === 'Iso' || noduleList.echogenicity === 'Hyper')
        && A_i()===false)
        return true;
    return false; 
}

  function getRiskOfMalignancy(){
    var risk = '';      
    // console.log(noduleList.orientation);  
    // console.log(noduleList);  

    // console.log(checkHighsuspicion(), checkIntermediateSuspicion(), checkLowSuspicion());
    if(!props.noduleClinic.normalThy){
        if(checkHighsuspicion()) return '[K-TIRADS 5, High suspicion]'; // A
        if(checkIntermediateSuspicion()) return '[K-TIRADS 4, Intermediate suspicion]'; // B
        if(checkLowSuspicion()) return '[K-TIRADS 3, Low suspicion]'; // C
    }
    return risk;
}
    const menuStyle = {
        backgroundColor:'#FEF3BD', 
        display : (props.menu===true ? '' : 'none'), 
        paddingLeft : 0,paddingRight : 0,
        width : '150px',
        maxWidth: '150px'
    }

    const normalMenuStyle = {
        display : (props.menu===true ? '' : 'none'), 
        paddingLeft : 0,paddingRight : 0,
        width : '150px', 
        maxWidth: '150px'
    }

    function handleCommentInputChange(e){
        clearTimeout(timer);
        timer = setTimeout(()=>{
            var _noduleList = {...noduleList};
            _noduleList.comment = e.target.value;
            setNoduleList(_noduleList);
        }, 500)
    }

    function handleCommentInputChangeClearTimer(e){
        clearTimeout(timer);
        var _noduleList = {...noduleList};
        _noduleList.comment = e.target.value;
        setNoduleList(_noduleList);
      }

    function handleNoteInputChange(e){
        clearTimeout(timer);
        timer = setTimeout(()=>{
            var _noduleList = {...noduleList};
            _noduleList.note = e.target.value;
            setNoduleList(_noduleList);
        }, 500)
    }

    function handleNoteInputChangeClearTimer(e){
        clearTimeout(timer);
        var _noduleList = {...noduleList};
        _noduleList.note = e.target.value;
        setNoduleList(_noduleList);
    }

    function handleDiameterValueChange(e, i){
        clearTimeout(timer);
        timer = setTimeout(()=>{
            var _noduleList = {...noduleList};
            var _noduleClinic = {...props.noduleClinic};

            _noduleList.diameter[3] = ''; // maximal size에 값을 넣고 또  AP, T, L값중 하나를 넣으려고 할때 기존에 넣은 maximal size값은 초기화
           
            if (i === 0){
                _noduleList.diameter[0] = e.target.value;

                if(_noduleList.diameter[0] !== '' && _noduleList.diameter[1] !== '' &&_noduleList.diameter[2] !== '' ){
                    _noduleList.diameter[4] = ((parseFloat(_noduleList.diameter[0]) * parseFloat(_noduleList.diameter[1]) * parseFloat(_noduleList.diameter[2])) * 0.5233).toFixed(2);
                    if(_noduleList.diameter[5] === 'mm') _noduleList.diameter[4] = (_noduleList.diameter[4] * 0.001).toFixed(2);    
                }
                else{_noduleList.diameter[4] = '';}

                if(noduleList.diameter[1] !== '' && noduleList.diameter[2] !== '')
                    _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[1]), parseFloat(_noduleList.diameter[2]));
                else if (noduleList.diameter[1] !== '')
                    _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[1]));
                else if (noduleList.diameter[2] !== '')
                    _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[2]));
                else if (noduleList.diameter[0] !== '')
                    _noduleList.diameter[3] = parseFloat(_noduleList.diameter[0]);
                else
                    _noduleList.diameter[3] = '';
                
                if(noduleList.diameter[0] === '') _noduleList.location.type = '';
                else {
                    _noduleClinic.normalThy = false;
                    _noduleList.location.type = props.title;
                }
                console.log(_noduleList.diameter);

            }
            else if (i === 1){
                _noduleList.diameter[1] = e.target.value;

                if(_noduleList.diameter[0] !== '' && _noduleList.diameter[1] !== '' &&_noduleList.diameter[2] !== '' ){
                    _noduleList.diameter[4] = ((parseFloat(_noduleList.diameter[0]) * parseFloat(_noduleList.diameter[1]) * parseFloat(_noduleList.diameter[2])) * 0.5233).toFixed(2);
                    if(_noduleList.diameter[5] === 'mm') _noduleList.diameter[4] = (_noduleList.diameter[4] * 0.001).toFixed(2);    
                }
                else{_noduleList.diameter[4] = '';}

                if(noduleList.diameter[0] !== '' && noduleList.diameter[2] !== '')
                    _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[1]), parseFloat(_noduleList.diameter[2]));
                else if (noduleList.diameter[0] !== '')
                    _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[1]));
                else if (noduleList.diameter[2] !== '')
                    _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[1]), parseFloat(_noduleList.diameter[2]));
                else if (noduleList.diameter[1] !== '')
                    _noduleList.diameter[3] = parseFloat(_noduleList.diameter[1]);
                else
                    _noduleList.diameter[3] = '';
            
                if(noduleList.diameter[1] === '') _noduleList.location.type = '';
                else {
                    _noduleClinic.normalThy = false;
                    _noduleList.location.type = props.title;
                }
                // console.log(_noduleList.diameter);
            }
            else if (i === 2) {
                _noduleList.diameter[2] = e.target.value;

                if(_noduleList.diameter[0] !== '' && _noduleList.diameter[1] !== '' &&_noduleList.diameter[2] !== '' ){
                    _noduleList.diameter[4] = ((parseFloat(_noduleList.diameter[0]) * parseFloat(_noduleList.diameter[1]) * parseFloat(_noduleList.diameter[2])) * 0.5233).toFixed(2);
                    if(_noduleList.diameter[5] === 'mm') _noduleList.diameter[4] = (_noduleList.diameter[4] * 0.001).toFixed(2);    
                }
                else{_noduleList.diameter[4] = '';}

                if(noduleList.diameter[0] !== '' && noduleList.diameter[1] !== '')
                    _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[1]), parseFloat(_noduleList.diameter[2]));
                else if (noduleList.diameter[0] !== '')
                    _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[2]));
                else if (noduleList.diameter[1] !== '')
                    _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[1]), parseFloat(_noduleList.diameter[2]));
                else if (noduleList.diameter[2] !== '')
                    _noduleList.diameter[3] = parseFloat(_noduleList.diameter[2]);
                else
                    _noduleList.diameter[3] = '';

                if(noduleList.diameter[2] === '') _noduleList.location.type = '';
                else {
                    _noduleClinic.normalThy = false;
                    _noduleList.location.type = props.title;
                }
                // console.log(_noduleList.diameter);

            }
            setMaximalSizeValue(_noduleList.diameter[3]);

            props.setNoduleClinic(_noduleClinic);
            setNoduleList(_noduleList);
        }, 500)
    }

    function handleDiameterValueChangeClearTimer(e, i){
        clearTimeout(timer);
        var _noduleList = {...noduleList};
        var _noduleClinic = {...props.noduleClinic};
       
        if (i === 0){
            _noduleList.diameter[0] = e.target.value;

            if(_noduleList.diameter[0] !== '' && _noduleList.diameter[1] !== '' &&_noduleList.diameter[2] !== '' ){
                _noduleList.diameter[4] = ((parseFloat(_noduleList.diameter[0]) * parseFloat(_noduleList.diameter[1]) * parseFloat(_noduleList.diameter[2])) * 0.5233).toFixed(2);
                if(_noduleList.diameter[5] === 'mm') _noduleList.diameter[4] = (_noduleList.diameter[4] * 0.001).toFixed(2);    
            }
            else{_noduleList.diameter[4] = '';}

            if(noduleList.diameter[1] !== '' && noduleList.diameter[2] !== '')
                _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[1]), parseFloat(_noduleList.diameter[2]));
            else if (noduleList.diameter[1] !== '')
                _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[1]));
            else if (noduleList.diameter[2] !== '')
                _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[2]));
            else if (noduleList.diameter[0] !== '')
                _noduleList.diameter[3] = parseFloat(_noduleList.diameter[0]);
            else
                _noduleList.diameter[3] = '';
            
            if(noduleList.diameter[0] === '') _noduleList.location.type = '';
            else {
                _noduleClinic.normalThy = false;
                _noduleList.location.type = props.title;
            }
        }
        else if (i === 1){
            _noduleList.diameter[1] = e.target.value;

            if(_noduleList.diameter[0] !== '' && _noduleList.diameter[1] !== '' &&_noduleList.diameter[2] !== '' ){
                _noduleList.diameter[4] = ((parseFloat(_noduleList.diameter[0]) * parseFloat(_noduleList.diameter[1]) * parseFloat(_noduleList.diameter[2])) * 0.5233).toFixed(2);
                if(_noduleList.diameter[5] === 'mm') _noduleList.diameter[4] = (_noduleList.diameter[4] * 0.001).toFixed(2);    
            }
            else{_noduleList.diameter[4] = '';}

            if(noduleList.diameter[0] !== '' && noduleList.diameter[2] !== '')
                _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[1]), parseFloat(_noduleList.diameter[2]));
            else if (noduleList.diameter[0] !== '')
                _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[1]));
            else if (noduleList.diameter[2] !== '')
                _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[1]), parseFloat(_noduleList.diameter[2]));
            else if (noduleList.diameter[1] !== '')
                _noduleList.diameter[3] = parseFloat(_noduleList.diameter[1]);
            else
                _noduleList.diameter[3] = '';
        
            if(noduleList.diameter[1] === '') _noduleList.location.type = '';
            else {
                _noduleClinic.normalThy = false;
                _noduleList.location.type = props.title;
            }
            // console.log(_noduleList.diameter);
        }
        else if (i === 2) {
            _noduleList.diameter[2] = e.target.value;

            if(_noduleList.diameter[0] !== '' && _noduleList.diameter[1] !== '' &&_noduleList.diameter[2] !== '' ){
                _noduleList.diameter[4] = ((parseFloat(_noduleList.diameter[0]) * parseFloat(_noduleList.diameter[1]) * parseFloat(_noduleList.diameter[2])) * 0.5233).toFixed(2);
                if(_noduleList.diameter[5] === 'mm') _noduleList.diameter[4] = (_noduleList.diameter[4] * 0.001).toFixed(2);    
            }
            else{_noduleList.diameter[4] = '';}

            if(noduleList.diameter[0] !== '' && noduleList.diameter[1] !== '')
                _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[1]), parseFloat(_noduleList.diameter[2]));
            else if (noduleList.diameter[0] !== '')
                _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[0]), parseFloat(_noduleList.diameter[2]));
            else if (noduleList.diameter[1] !== '')
                _noduleList.diameter[3] = Math.max(parseFloat(_noduleList.diameter[1]), parseFloat(_noduleList.diameter[2]));
            else if (noduleList.diameter[2] !== '')
                _noduleList.diameter[3] = parseFloat(_noduleList.diameter[2]);
            else
                _noduleList.diameter[3] = '';

            if(noduleList.diameter[2] === '') _noduleList.location.type = '';
            else {
                _noduleClinic.normalThy = false;
                _noduleList.location.type = props.title;
            }
            console.log(_noduleList.diameter);

        }
        setMaximalSizeValue(_noduleList.diameter[3]);

        props.setNoduleClinic(_noduleClinic);
        setNoduleList(_noduleList);
    }


    function handleMaximalSizeValueChange(e, i){
        clearTimeout(timer);
        timer = setTimeout(()=>{
            var _noduleList = {...noduleList};
            var _noduleClinic = {...props.noduleClinic};

            _noduleList.diameter[3] = e.target.value;

            if(_noduleList.diameter[3] !== ''){
                _noduleList.diameter[0] = ''; // AP값을 넣고 Maximal sizd에 값을 넣으려고 할때 기존에 넣은 AP 값은 초기화
                _noduleList.diameter[1] = ''; // T값을 넣고 Maximal sizd에 값을 넣으려고 할때 기존에 넣은 T값은 초기화
                _noduleList.diameter[2] = ''; // L을 넣고 Maximal sizd에 값을 넣으려고 할때 기존에 넣은 L값은 초기화
                _noduleList.diameter[4] = ''; // volume 값이 계산된 후 Maximal sizd에 값을 넣으려고 할때 volume 값 초기화
                setDiameterValue('');
                setDiameterValue1('');
                setDiameterValue2('');
            }

            if(noduleList.diameter[3] === '') _noduleList.location.type = '';
            else {
                _noduleClinic.normalThy = false;
                _noduleList.location.type = props.title;
            }

            props.setNoduleClinic(_noduleClinic);
            setNoduleList(_noduleList);
        }, 500)
    }

    function handleMaximalSizeValueChangeClearTimer(e, i){
        clearTimeout(timer);
        var _noduleList = {...noduleList};
        var _noduleClinic = {...props.noduleClinic};

        _noduleList.diameter[3] = e.target.value;

        if(_noduleList.diameter[3] !== ''){
            _noduleList.diameter[0] = ''; // AP값을 넣고 Maximal sizd에 값을 넣으려고 할때 기존에 넣은 AP 값은 초기화
            _noduleList.diameter[1] = ''; // T값을 넣고 Maximal sizd에 값을 넣으려고 할때 기존에 넣은 T값은 초기화
            _noduleList.diameter[2] = ''; // L을 넣고 Maximal sizd에 값을 넣으려고 할때 기존에 넣은 L값은 초기화
            _noduleList.diameter[4] = ''; // volume 값이 계산된 후 Maximal sizd에 값을 넣으려고 할때 volume 값 초기화
            setDiameterValue('');
            setDiameterValue1('');
            setDiameterValue2('');
        }

        if(noduleList.diameter[3] === '') _noduleList.location.type = '';
        else {
            _noduleClinic.normalThy = false;
            _noduleList.location.type = props.title;
        }

        props.setNoduleClinic(_noduleClinic);
        setNoduleList(_noduleList);
    }

    function handleExtrathyroidalGrossInputChange(e){
        clearTimeout(timer);
        timer = setTimeout(()=>{
            var _noduleList = {...noduleList};
            _noduleList.extrathyroidalGross.input = e.target.value;
            setNoduleList(_noduleList);
        }, 500)
    }

    function handleExtrathyroidalGrossInputChangeClearTimer(e){
        clearTimeout(timer);
        var _noduleList = {...noduleList};
        _noduleList.extrathyroidalGross.input = e.target.value;
        setNoduleList(_noduleList);
    }

    function handleBiopsyFnAChange(e){
        clearTimeout(timer);
        timer = setTimeout(()=>{
            var _noduleList = {...noduleList};
            _noduleList.biopsy.FnaDevice = e.target.value;
            setNoduleList(_noduleList);
        }, 500)
    }

    function handleBiopsyFnAChangeClearTimer(e){
        clearTimeout(timer);
        var _noduleList = {...noduleList};
        _noduleList.biopsy.FnaDevice = e.target.value;
        setNoduleList(_noduleList);
    }

    function handleBiopsyCnbChange(e){
        clearTimeout(timer);
        timer = setTimeout(()=>{
            var _noduleList = {...noduleList};
            _noduleList.biopsy.CnbSize = e.target.value;
            setNoduleList(_noduleList);
        }, 500)
    }

    function handleBiopsyCnbChangeClearTimer(e){
        clearTimeout(timer);
        var _noduleList = {...noduleList};
        _noduleList.biopsy.CnbSize = e.target.value;
        setNoduleList(_noduleList);
    }

    function handleComplicationsOthersTxtChange(e){
        clearTimeout(timer);
        timer = setTimeout(()=>{
            var _noduleList = {...noduleList};
            _noduleList.complications.othersTxt = e.target.value;
            setNoduleList(_noduleList);
        }, 500)
    }

    function handleComplicationsOthersTxtChangeClearTimer(e){
        clearTimeout(timer);
        var _noduleList = {...noduleList};
        _noduleList.complications.othersTxt = e.target.value;
        setNoduleList(_noduleList);
    }

// style={{display : props.menu ? 'block' : 'none'}}
  return (      
    <div className={classes.root}> 
    {
        props.display === false ? <></> : 
    
      <TableContainer component={Paper}>
      <Table id='thyroid-abc' size='small' className={classes.table} aria-label="simple table">
        <TableBody>
            <TableRow>
                <TableCell align="center" className={classes.tableRightBorder} rowSpan={2} style={menuStyle}>* Location</TableCell>
                <TableCell align="center" className={classes.tableRightBorder}>{props.title}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell align="left" className={classes.tableRightBorder}>
                    <RadioGroup row aria-label="position" name="position" value={noduleList.location.position} 
                        onChange={(event) => {
                            var _noduleList = {...noduleList};
                            var _noduleClinic = {...props.noduleClinic};                                
                            _noduleList.location.position = event.target.value;
                            _noduleList.location.type = props.title;
                            _noduleClinic.normalThy = false;
                            props.setNoduleClinic(_noduleClinic);
                            setNoduleList(_noduleList);}}>
                        <FormControlLabel value="upper" control={<Radio color="primary" size='small' disabled ={props.noduleClinic.normalThy} onClick={(event) => handleClickRadioLocation(event.target.value, 0)}/>} label="Upper" labelPlacement="end" />
                        <FormControlLabel value="middle" control={<Radio color="primary" size='small' disabled ={props.noduleClinic.normalThy} onClick={(event) => handleClickRadioLocation(event.target.value, 0)}/>} label="Middle" labelPlacement="end"/>
                        <FormControlLabel value="lower" control={<Radio color="primary" size='small' disabled ={props.noduleClinic.normalThy} onClick={(event) => handleClickRadioLocation(event.target.value, 0)}/>} label="Lower" labelPlacement="end" />
                    </RadioGroup>
                </TableCell>
            </TableRow>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={menuStyle}>* Diameter</TableCell>
            <TableCell align="left" className={classes.tableRightBorder}>
                (<TextField id="outlined-basic" disabled ={props.noduleClinic.normalThy} size="small" style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}}
                defaultValue={diameterValue} value={diameterValue} 
                placeholder = "AP"
                onChange={(event) => {
                    var _diameterValue = {...diameterValue};
                    _diameterValue = event.target.value;
                    setDiameterValue(_diameterValue);
                    handleDiameterValueChange(event, 0);
                }} onBlur = {(event) => {
                    handleDiameterValueChangeClearTimer(event, 0);
                }}
                /> X 
                <TextField id="outlined-basic" disabled ={props.noduleClinic.normalThy} size="small" style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}}
                defaultValue={diameterValue1} value={diameterValue1} 
                placeholder = "T"
                onChange={(event) => {
                    var _diameterValue1 = {...diameterValue1};
                    _diameterValue1 = event.target.value;
                    setDiameterValue1(_diameterValue1);
                    handleDiameterValueChange(event, 1);
                }} onBlur = {(event) => {
                    handleDiameterValueChangeClearTimer(event, 1);
                }}/> 
                X 
                <TextField id="outlined-basic" disabled ={props.noduleClinic.normalThy} size="small" style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}}
                defaultValue={diameterValue2} value={diameterValue2}  
                placeholder = "L"
                onChange={(event) => {
                    var _diameterValue2 = {...diameterValue2};
                    _diameterValue2 = event.target.value;
                    setDiameterValue2(_diameterValue2);
                    handleDiameterValueChange(event, 2);
                }} onBlur = {(event) => {
                    handleDiameterValueChangeClearTimer(event, 2);
                }}/>) &nbsp;
                    <select name="unit" disabled={props.noduleClinic.normalThy} defaultValue={diameterUnit} value={noduleList.diameter[5]} onChange={(event) => {   
                        var _noduleList = {...noduleList};
                        _noduleList.diameter[5] = event.target.value;
                        if(_noduleList.diameter[5] === 'mm') setDiameterUnit('mm');
                        else setDiameterUnit('cm');
                        if(_noduleList.diameter[0] !== '' && _noduleList.diameter[1] !== '' &&_noduleList.diameter[2] !== '' ){
                            if(_noduleList.diameter[5] === 'mm'){
                                _noduleList.diameter[4] = (((parseFloat(_noduleList.diameter[0]) * parseFloat(_noduleList.diameter[1]) * parseFloat(_noduleList.diameter[2])) * 0.5233) * 0.001).toFixed(2); 
                            }
                            else {
                                _noduleList.diameter[4] = ((parseFloat(_noduleList.diameter[0]) * parseFloat(_noduleList.diameter[1]) * parseFloat(_noduleList.diameter[2])) * 0.5233).toFixed(2); 
                            }
                        }
                        setNoduleList(_noduleList);
                    }}>
                        <option value="cm">cm</option>
                        <option value="mm">mm</option>
                    </select> 
                    <div> Maximal size = <TextField id="outlined-basic" disabled ={props.noduleClinic.normalThy} size="small" style={{width:'50px', maxWidth:'150px'}} inputProps={{style: { textAlign: 'center' }}} defaultValue= {maximalSizeValue} value={maximalSizeValue}
                    onChange={(event) => {
                        var _maximalsizeValue = {...maximalSizeValue};
                        _maximalsizeValue = event.target.value;
                        setMaximalSizeValue(_maximalsizeValue);
                        handleMaximalSizeValueChange(event, 3);
                    }} onBlur = {(event) => {
                        handleMaximalSizeValueChangeClearTimer(event, 3);
                    }}
                    /> {noduleList.diameter[5]}
                    , Volume=<TextField aria-readonly id="outlined-basic" disabled ={props.noduleClinic.normalThy} size="small" style={{width:'70px'}} inputProps={{style: { textAlign: 'center' }}} defaultValue= {noduleList.diameter[4]} value={noduleList.diameter[4]}/>mL</div>
            </TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Composition</TableCell>
            <TableCell align="left" className={classes.tableRightBorder}>
                <RadioGroup row aria-label="position" name="position" disabled ={props.noduleClinic.normalThy} value={noduleList.composition} 
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.composition = event.target.value;
                        noduleList.composition = event.target.value;
                        setNoduleList(_noduleList);
                        /** recommendation - start **/
                        var max_diameter = 0;
                        var _noduleList = {...noduleList};

                        if(_noduleList.diameter[5] === 'mm') max_diameter = _noduleList.diameter[3] * 0.1;
                        else max_diameter = _noduleList.diameter[3];
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 5, High suspicion]' && max_diameter >= 1) setNoduleRecommendation('K-TIRADS 5,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && max_diameter >= 1.5) setNoduleRecommendation('K-TIRADS 4,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 3, Low suspicion]' && max_diameter >= 2) setNoduleRecommendation('K-TIRADS 3,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && _noduleList.diffuseLesion) setNoduleRecommendation('K-TIRADS 4,\nCNB recommendation');
                        /** recommendation - end **/
                        }}>
                    <FormControlLabel value="Solid" control={<Radio color="primary" size='small' disabled ={noduleList.calcification.entire === 'entire' || noduleList.spongiform === 'Yes' || props.noduleClinic.normalThy} onClick={(event) => handleClickRadioCompos(event.target.value, 0)}/>} label="Solid" labelPlacement="end" />
                    <FormControlLabel value="P.Solid" control={<Radio color="primary" size='small' disabled ={noduleList.calcification.entire === 'entire' || props.noduleClinic.normalThy} onClick={(event) => handleClickRadioCompos(event.target.value, 0)}/>} label="P.Solid" labelPlacement="end"/>
                    <FormControlLabel value="P.Cystic" control={<Radio color="primary" size='small' disabled ={noduleList.calcification.entire === 'entire' || props.noduleClinic.normalThy} onClick={(event) => handleClickRadioCompos(event.target.value, 0)}/>} label="P.Cystic" labelPlacement="end" />
                    <FormControlLabel value="Cystic" control={<Radio color="primary" size='small' disabled ={noduleList.calcification.entire === 'entire' || props.noduleClinic.normalThy} onClick={(event) => handleClickRadioCompos(event.target.value, 0)}/>} label="Cystic" labelPlacement="end" />
                </RadioGroup>
            </TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Echogenicity</TableCell>
            <TableCell align="left" className={classes.tableRightBorder}>
                <RadioGroup row aria-label="position" name="position" disabled ={props.noduleClinic.normalThy} value={noduleList.echogenicity}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.echogenicity = event.target.value;
                        noduleList.echogenicity = event.target.value;
                        setNoduleList(_noduleList);
                        /** recommendation - start **/
                        var max_diameter = 0;
                        var _noduleList = {...noduleList};

                        if(_noduleList.diameter[5] === 'mm') max_diameter = _noduleList.diameter[3] * 0.1;
                        else max_diameter = _noduleList.diameter[3];
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 5, High suspicion]' && max_diameter >= 1) setNoduleRecommendation('K-TIRADS 5,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && max_diameter >= 1.5) setNoduleRecommendation('K-TIRADS 4,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 3, Low suspicion]' && max_diameter >= 2) setNoduleRecommendation('K-TIRADS 3,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && _noduleList.diffuseLesion) setNoduleRecommendation('K-TIRADS 4,\nCNB recommendation');
                        /** recommendation - end **/
                        }}>
                    <FormControlLabel value="Marked hypo" disabled={noduleList.calcification.entire === 'entire' ||  props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioEcho(event.target.value, 0)}/>} label="Marked hypo" labelPlacement="end"/>
                    <FormControlLabel value="Mild hypo" disabled={noduleList.calcification.entire === 'entire' || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioEcho(event.target.value, 0)}/>} label="Mild hypo" labelPlacement="end" />
                    <FormControlLabel value="Iso" disabled={noduleList.calcification.entire === 'entire' || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioEcho(event.target.value, 0)}/>} label="Iso" labelPlacement="end" />
                    <FormControlLabel value="Hyper" disabled={noduleList.calcification.entire === 'entire' || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioEcho(event.target.value, 0)}/>} label="Hyper" labelPlacement="end"/>
                </RadioGroup>
            </TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Size Change</TableCell>
            <TableCell align="left" className={classes.tableRightBorder}>
                <FormControlLabel control={<Checkbox name="initial" color="primary" disabled ={props.noduleClinic.normalThy} 
                    defaultChecked={noduleList.changeInSize.initial} size='small' checked={noduleList.changeInSize.initial}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.changeInSize.initial = event.target.checked;
                        _noduleList.changeInSize.followup = false;
                        _noduleList.changeInSize.value = '';
                        setNoduleList(_noduleList);}}/>} label="Initial"/>
                <FormControlLabel control={<Checkbox name="followup" color="primary" 
                    disabled={noduleList.changeInSize.initial || props.noduleClinic.normalThy}
                    defaultChecked={noduleList.changeInSize.followup} size='small' checked={noduleList.changeInSize.followup}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.changeInSize.followup = event.target.checked;
                        if(!_noduleList.changeInSize.followup){
                            _noduleList.changeInSize.value = '';
                        }
                        setNoduleList(_noduleList);}}/>} label="Follow-up"/>
                <RadioGroup row aria-label="position" name="position" value={noduleList.changeInSize.value}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.changeInSize.value = event.target.value;
                        setNoduleList(_noduleList);
                        }}>
                        <div style={{marginTop:'10px'}}>
                            (<FormControlLabel value="New" control={<Radio color="primary" size='small' disabled={!noduleList.changeInSize.followup || props.noduleClinic.normalThy} onClick={(event) =>handleClickRadioChangeInSize(event.target.value)}/>} label="New" labelPlacement="end" />
                            <FormControlLabel value="Increased" control={<Radio color="primary" size='small' disabled={!noduleList.changeInSize.followup || props.noduleClinic.normalThy} onClick={(event) =>handleClickRadioChangeInSize(event.target.value)}/>} label="Increased" labelPlacement="end" />
                            <FormControlLabel value="Decreased" control={<Radio color="primary" size='small' disabled={!noduleList.changeInSize.followup || props.noduleClinic.normalThy} onClick={(event) => handleClickRadioChangeInSize(event.target.value)}/>} label="Decreased" labelPlacement="end"/>
                            <FormControlLabel value="Stable" control={<Radio color="primary" size='small' disabled={!noduleList.changeInSize.followup || props.noduleClinic.normalThy} onClick={(event) => handleClickRadioChangeInSize(event.target.value)}/>} label="Stable" labelPlacement="end" />)
                        </div>
                </RadioGroup>
            </TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Orientation</TableCell>
            <TableCell align="left" className={classes.tableRightBorder}>
                <RadioGroup row aria-label="position" name="position" value={noduleList.orientation}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        noduleList.orientation = event.target.value;
                        _noduleList.orientation = event.target.value;
                        setNoduleList(_noduleList);
                        /** recommendation - start **/
                        var max_diameter = 0;
                        if(_noduleList.diameter[5] === 'mm') max_diameter = _noduleList.diameter[3] * 0.1;
                        else max_diameter = _noduleList.diameter[3];
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 5, High suspicion]' && max_diameter >= 1) setNoduleRecommendation('K-TIRADS 5,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && max_diameter >= 1.5) setNoduleRecommendation('K-TIRADS 4,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 3, Low suspicion]' && max_diameter >= 2) setNoduleRecommendation('K-TIRADS 3,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && _noduleList.diffuseLesion) setNoduleRecommendation('K-TIRADS 4,\nCNB recommendation');
                        /** recommendation - end **/  
                    }}>
                    <FormControlLabel value="Parallel" disabled ={noduleList.calcification.entire === 'entire' || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioOri(event.target.value, 0)}/>} label="Parallel" labelPlacement="end" />
                    <FormControlLabel value="Nonparallel" disabled ={noduleList.calcification.entire === 'entire' || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioOri(event.target.value, 0)}/>} label="Nonparallel (taller-than-wide)" labelPlacement="end" />
                </RadioGroup>
            </TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Margin</TableCell>
            <TableCell align="left" className={classes.tableRightBorder}>
                <RadioGroup row aria-label="position" name="position" value={noduleList.margin} disabled={props.noduleClinic.normalThy}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.margin = event.target.value;
                        setNoduleList(_noduleList);}}>
                    <FormControlLabel value="Smooth" disabled ={noduleList.calcification.entire === 'entire' || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioMargin(event.target.value, 0)}/>} label="Smooth"labelPlacement="end" />
                    <FormControlLabel value="Ill-defined" disabled ={noduleList.calcification.entire === 'entire' || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioMargin(event.target.value, 0)}/>} label="Ill-defined" labelPlacement="end" /> 
                    <FormControlLabel value="Irregular (spiculated/microlobulated)" disabled ={noduleList.calcification.entire === 'entire' || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioMargin(event.target.value, 0)}/>} label="Irregular (spiculated/microlobulated)" labelPlacement="end" />
                </RadioGroup>
            </TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Echogenic foci (calcification)</TableCell>
            <TableCell align="left" className={classes.tableRightBorder}>
                <FormControlLabel control={<Checkbox name="mic" color="primary" disabled={props.noduleClinic.normalThy}
                    defaultChecked={noduleList.calcification.micro} size='small' checked={noduleList.calcification.micro}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.calcification.micro = event.target.checked;
                        setNoduleList(_noduleList);
                        /** recommendation - start **/
                        var max_diameter = 0;
                        if(_noduleList.diameter[5] === 'mm') max_diameter = _noduleList.diameter[3] * 0.1;
                        else max_diameter = _noduleList.diameter[3];
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 5, High suspicion]' && max_diameter >= 1) setNoduleRecommendation('K-TIRADS 5,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && max_diameter >= 1.5) setNoduleRecommendation('K-TIRADS 4,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 3, Low suspicion]' && max_diameter >= 2) setNoduleRecommendation('K-TIRADS 3,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && _noduleList.diffuseLesion) setNoduleRecommendation('K-TIRADS 4,\nCNB recommendation');
                        /** recommendation - end **/
                        }}/>} label="Punctate echogenic foci (microcalcification)"/>
                <FormControlLabel control={<Checkbox name="rim" color="primary" disabled={props.noduleClinic.normalThy}
                    defaultChecked={noduleList.calcification.rim} size='small' checked={noduleList.calcification.rim}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.calcification.rim = event.target.checked;
                        setNoduleList(_noduleList);}}/>} label="Rim"/>
                <FormControlLabel control={<Checkbox name="mac" color="primary" disabled={props.noduleClinic.normalThy}
                    defaultChecked={noduleList.calcification.macro} size='small' checked={noduleList.calcification.macro}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.calcification.macro = event.target.checked;
                        if(!_noduleList.calcification.macro) noduleList.calcification.entire = '';
                        setNoduleList(_noduleList);}}/>} label="Macro"/>
                <RadioGroup row aria-label="position" name="position" value={noduleList.calcification.entire}
                    onChange={(event) => {
                    var _noduleList = {...noduleList};
                    _noduleList.calcification.entire = event.target.value;
                    setNoduleList(_noduleList);
                    }}>
                    <div style={{marginTop:'10px'}}>
                        (&nbsp;<FormControlLabel value='entire' disabled={!noduleList.calcification.macro || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioCalcification(event.target.value, 0)}/>} label="Entired calcified nodule" labelPlacement="end"/>)
                    </div> 
                </RadioGroup>
            </TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Vascularity</TableCell>
            <TableCell align="left" className={classes.tableRightBorder}>
                {/* <RadioGroup row aria-label="position" name="position" value={noduleList.vascularity}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.vascularity = event.target.value;
                        setNoduleList(_noduleList);}}>
                    <FormControlLabel value="none" disabled={props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioVascularity(event.target.value)}/>} label="None" labelPlacement="end" />
                    <FormControlLabel value="peripheral" disabled={props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioVascularity(event.target.value)}/>} label="Peripheral" labelPlacement="end" />
                    <FormControlLabel value="mildIntranodular" disabled={props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioVascularity(event.target.value)}/>} label="Mild intranodular" labelPlacement="end" />
                    <FormControlLabel value="markedIntranodular" disabled={props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioVascularity(event.target.value)}/>} label="Marked intranodular" labelPlacement="end" />
                </RadioGroup> */}
                <FormControlLabel control={<Checkbox name="none" color="primary" size='small' disabled={props.noduleClinic.normalTh || noduleList.vascularity.peripheral || noduleList.vascularity.marked || noduleList.vascularity.mild}
                defaultChecked={noduleList.vascularity.none} checked={noduleList.vascularity.none}
                onChange={(event) => {
                    var _noduleList = {...noduleList};
                    _noduleList.vascularity.none = event.target.checked;
                    setNoduleList(_noduleList);
                    }}/>} label="None"/>
                <FormControlLabel control={<Checkbox name="peri" color="primary" size='small' disabled={props.noduleClinic.normalThy}
                defaultChecked={noduleList.vascularity.peripheral} checked={noduleList.vascularity.peripheral} onChange={(event) => { 
                    var _noduleList = {...noduleList};
                    _noduleList.vascularity.peripheral = event.target.checked;
                    setNoduleList(_noduleList);
                }}/>} label="Peripheral"/>
                <FormControlLabel control={<Checkbox name="mild" color="primary" size='small' disabled={props.noduleClinic.normalThy || noduleList.vascularity.marked}
                defaultChecked={noduleList.vascularity.mild} checked={noduleList.vascularity.mild} onChange={(event) => { 
                    var _noduleList = {...noduleList};
                    _noduleList.vascularity.mild = event.target.checked;
                    setNoduleList(_noduleList);
                }}/>} label="Mild intranodular"/>
                <FormControlLabel control={<Checkbox name="mark" color="primary" size='small' disabled={props.noduleClinic.normalThy || noduleList.vascularity.mild}
                defaultChecked={noduleList.vascularity.marked} checked={noduleList.vascularity.marked} onChange={(event) => { 
                    var _noduleList = {...noduleList};
                    _noduleList.vascularity.marked = event.target.checked;
                    setNoduleList(_noduleList);
                }}/>} label="Marked intranodular"/>
            </TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Spongiform</TableCell>
            <TableCell align="left" className={classes.tableRightBorder}>
                <RadioGroup row aria-label="position" name="position" value={noduleList.spongiform}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.spongiform = event.target.value;
                        setNoduleList(_noduleList);}}>
                    <FormControlLabel value="Yes" disabled={noduleList.composition === 'Solid' || noduleList.composition === 'Cystic' || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioSpongi(event.target.value, 0)}/>} label="Yes" labelPlacement="end" />
                </RadioGroup>
            </TableCell>
        </TableBody>
        <TableBody>
            <TableRow>
                <TableCell align="center" className={classes.tableRightBorder} rowSpan={2} style={normalMenuStyle}>Intracystic echogenic foci with comet tail artifact</TableCell>
            </TableRow>
            <TableRow>
                <TableCell align="left" className={classes.tableRightBorder}>
                    <RadioGroup row aria-label="position" name="position" value={noduleList.cometTailArtifact}
                        onChange={(event) => {
                            var _noduleList = {...noduleList};
                            _noduleList.cometTailArtifact = event.target.value;
                            setNoduleList(_noduleList);}}>
                        <FormControlLabel style={{height : '100px'}} value="Yes" disabled={noduleList.composition === 'Solid' || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioTail(event.target.value, 0)}/>} label="Yes" labelPlacement="end" />
                    </RadioGroup>
                </TableCell>
            </TableRow>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Diffuse lesion</TableCell>
            <TableCell align="left" className={classes.tableRightBorder}>
                <RadioGroup row aria-label="position" name="position" value={noduleList.diffuseLesion}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.diffuseLesion = event.target.value;
                        noduleList.diffuseLesion = event.target.value;
                        setNoduleList(_noduleList);
                        /** recommendation - start **/
                        var max_diameter = 0;
                        if(_noduleList.diameter[5] === 'mm') max_diameter = _noduleList.diameter[3] * 0.1;
                        else max_diameter = _noduleList.diameter[3];
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 5, High suspicion]' && max_diameter >= 1) setNoduleRecommendation('K-TIRADS 5,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && max_diameter >= 1.5) setNoduleRecommendation('K-TIRADS 4,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 3, Low suspicion]' && max_diameter >= 2) setNoduleRecommendation('K-TIRADS 3,\nBiopsy recommendation');
                        if(getRiskOfMalignancy(0) === '[K-TIRADS 4, Intermediate suspicion]' && _noduleList.diffuseLesion) setNoduleRecommendation('K-TIRADS 4,\nCNB recommendation');
                        /** recommendation - end **/
                        }}>
                    <FormControlLabel value="extensive" control={<Radio color="primary" size='small' disabled={props.noduleClinic.normalThy} onClick={(event) => handleClickRadioDiffuse(event.target.value, 0)}/>} label="Extensive parenchymal PEF" labelPlacement="end" />
                    <FormControlLabel value="infiltrative" control={<Radio color="primary" size='small' disabled={props.noduleClinic.normalThy} onClick={(event) => handleClickRadioDiffuse(event.target.value, 0)}/>} label="Diffuse infiltrative lesion" labelPlacement="end" />                    
                </RadioGroup>
            </TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Extrathyroidal extension (ETE)</TableCell>
            <TableCell align="left" className={classes.tableRightBorder}>
                <RadioGroup row aria-label="position" name="position" value={noduleList.extrathyroidal}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.extrathyroidal = event.target.value;
                        if(_noduleList.extrathyroidal === 'No ETE') {
                            _noduleList.extrathyroidal2 = '';
                        }
                        setNoduleList(_noduleList);
                        }}>
                    <FormControlLabel value="No ETE" control={<Radio color="primary" size='small' disabled={props.noduleClinic.normalThy} onClick={(event) => handleClickRadioExtrathyroidal(event.target.value, 0)}/>} label="No ETE" labelPlacement="end" />
                    <FormControlLabel value="Minor ETE" control={<Radio color="primary" size='small' disabled={props.noduleClinic.normalThy} onClick={(event) => handleClickRadioExtrathyroidal(event.target.value, 0)}/>} label="Minor ETE" labelPlacement="end" />
                    <RadioGroup row aria-label="position" name="position" value={noduleList.extrathyroidal}
                        onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.extrathyroidal = event.target.value;
                        setNoduleList(_noduleList);
                        }}>
                        <div style={{marginTop:'10px'}}>
                            (&nbsp;<FormControlLabel value="ant" control={<Checkbox name="ant" color="primary" size='small' disabled={noduleList.extrathyroidal !== 'Minor ETE' || props.noduleClinic.normalThy}
                            defaultChecked={noduleList.extrathyroidalLocation.ant} checked={noduleList.extrathyroidalLocation.ant}
                            onChange={(event) => {
                                var _noduleList = {...noduleList};
                                _noduleList.extrathyroidalLocation.ant = event.target.checked;
                                setNoduleList(_noduleList);}}/>} label="ant" labelPlacement="end"/>  
                            <FormControlLabel value="post" control={<Checkbox name="post" color="primary" size='small' disabled={noduleList.extrathyroidal !== 'Minor ETE' || props.noduleClinic.normalThy}
                            defaultChecked={noduleList.extrathyroidalLocation.post} checked={noduleList.extrathyroidalLocation.post}
                            onChange={(event) => {
                                var _noduleList = {...noduleList};
                                _noduleList.extrathyroidalLocation.post = event.target.checked;
                                setNoduleList(_noduleList);}}/>} label="post" labelPlacement="end"/>)&nbsp;
                        </div> 
                    </RadioGroup>
                </RadioGroup>
                <RadioGroup row aria-label="position" name="position" value={noduleList.extrathyroidal2}
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.extrathyroidal2 = event.target.value;
                        if(_noduleList.extrathyroidal === 'No ETE') {
                            _noduleList.extrathyroidal = '';
                        }
                        setNoduleList(_noduleList);
                        }}>
                    <br/><FormControlLabel value="Gross ETE" control={<Radio color="primary" size='small' disabled={props.noduleClinic.normalThy} onClick={(event) => handleClickRadioExtrathyroidal2(event.target.value, 0)}/>} label="Gross ETE" labelPlacement="end" />
                    <RadioGroup row aria-label="position" name="position" value={noduleList.extrathyroidalGross}
                        onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.extrathyroidalGross = event.target.value;
                        setNoduleList(_noduleList);
                        }}>
                        <div style={{marginTop:'10px'}}>
                            (&nbsp;<FormControlLabel value="trachea" control={<Checkbox name="trachea" color="primary" size='small' disabled={noduleList.extrathyroidal2 !== 'Gross ETE' || props.noduleClinic.normalThy}
                            defaultChecked={noduleList.extrathyroidalGross.trachea} checked={noduleList.extrathyroidalGross.trachea}
                            onChange={(event) => {
                                var _noduleList = {...noduleList};
                                _noduleList.extrathyroidalGross.trachea = event.target.checked;
                                setNoduleList(_noduleList);}}/>} label="trachea" labelPlacement="end"/>  
                            <FormControlLabel value="RLN" control={<Checkbox name="RLN" color="primary" size='small' disabled={noduleList.extrathyroidal2 !== 'Gross ETE' || props.noduleClinic.normalThy}
                            defaultChecked={noduleList.extrathyroidalGross.trachea} checked={noduleList.extrathyroidalGross.RLN}
                            onChange={(event) => {
                                var _noduleList = {...noduleList};
                                _noduleList.extrathyroidalGross.RLN = event.target.checked;
                                setNoduleList(_noduleList);}}/>} label="RLN" labelPlacement="end"/> 
                            <FormControlLabel value="strap" control={<Checkbox name="strap" color="primary" size='small' disabled={noduleList.extrathyroidal2 !== 'Gross ETE' || props.noduleClinic.normalThy}
                            defaultChecked={noduleList.extrathyroidalGross.strap} checked={noduleList.extrathyroidalGross.strap}
                            onChange={(event) => {
                                var _noduleList = {...noduleList};
                                _noduleList.extrathyroidalGross.strap = event.target.checked;
                                setNoduleList(_noduleList);}}/>} label="strap muscle" labelPlacement="end"/> 
                            <FormControlLabel value="others" control={<Checkbox name="others" color="primary" size='small' disabled={noduleList.extrathyroidal2 !== 'Gross ETE' || props.noduleClinic.normalThy}
                            defaultChecked={noduleList.extrathyroidalGross.others} checked={noduleList.extrathyroidalGross.others}
                            onChange={(event) => {
                                var _noduleList = {...noduleList};
                                _noduleList.extrathyroidalGross.others = event.target.checked;
                                if(!_noduleList.extrathyroidalGross.others) noduleList.extrathyroidalGross.input = '';
                                setNoduleList(_noduleList);}}/>} label="others" labelPlacement="end"/> 
                            <TextField id="outlined-basic" style={{width:'100px'}} disabled={!noduleList.extrathyroidalGross.others || props.noduleClinic.normalThy} size="small" defaultValue={extrathyroidalGrossInput} value={extrathyroidalGrossInput} onChange={(event) => {
                                setExtrathyroidalGrossInput(event.target.value);
                                handleExtrathyroidalGrossInputChange(event);}} onBlur={(event) => {
                                    handleExtrathyroidalGrossInputChangeClearTimer(event);
                                }}/>)
                        </div> 
                    </RadioGroup>
                </RadioGroup>
            </TableCell>
            </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Comment</TableCell>
              <TableCell align="left" className={classes.tableRightBorder}>
                  <TextField id="outlined-multiline-static" multiline rows={4} variant="outlined" disabled={props.noduleClinic.normalThy} style={{width:'100%'}} defaultValue={saveComment} value={saveComment} onChange={(event) => { 
                      var _saveComment = {...saveComment};
                      _saveComment = event.target.value;
                      setSaveComment(_saveComment);
                      handleCommentInputChange(event);}} onBlur={(event => {
                        handleCommentInputChangeClearTimer(event);
                      })}/>
              </TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" colSpan={3} style={{backgroundColor:"grey", color:'white'}}>Biopsy</TableCell>
        </TableBody>
        <TableBody>
            <TableRow>
                <TableCell align="center" rowSpan={2} className={classes.tableRightBorder} style={normalMenuStyle}>Biopsy</TableCell>
                <TableCell align="left" className={classes.tableRightBorder}>
                    <FormControlLabel control={<Checkbox name="yes" color="primary" size='small' disabled={props.noduleClinic.normalThy}
                    defaultChecked={noduleList.biopsy.onChecked} checked={noduleList.biopsy.onChecked} 
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.biopsy.onChecked = event.target.checked;
                        if(!_noduleList.biopsy.onChecked) {
                            _noduleList.biopsy.FnaDevice = '';
                            _noduleList.biopsy.CnbSize = '';
                            _noduleList.complications.yes = false;
                            _noduleList.complications.no = false;
                        }
                        setNoduleList(_noduleList);}}/>} label="Yes"/>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell align="left" className={classes.tableRightBorder}>                    
                    <RadioGroup row aria-label="position" name="position" value={noduleList.biopsy.type}
                        onChange={(event) => {
                            var _noduleList = {...noduleList};
                            _noduleList.biopsy.type = event.target.value;
                            if(_noduleList.biopsy.type === 'FNA') _noduleList.biopsy.CnbSize = '';
                            else _noduleList.biopsy.FnaDevice = '';
                            setNoduleList(_noduleList);}}>
                        <div style={{marginTop:'10px'}}>
                            <FormControlLabel value="FNA" disabled={!noduleList.biopsy.onChecked} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioBiopsy(event.target.value)}/>} label="FNA" labelPlacement="end"/>
                            (<TextField disabled={noduleList.biopsy.type !== 'FNA' || props.noduleClinic.normalThy} size="small" defaultValue={biopsyFnaDevice} value={biopsyFnaDevice} style={{width:'80px'}} inputProps={{style: { textAlign: 'center' }}} onChange={(event) => {
                                setBiopsyFnaDevice(event.target.value);
                                handleBiopsyFnAChange(event);}} onBlur={(event) => {
                                    handleBiopsyFnAChangeClearTimer(event);
                                }}/>)G &nbsp; &nbsp;
                            <FormControlLabel value="CNB" disabled={!noduleList.biopsy.onChecked} control={<Radio color="primary" size='small' onClick={(event) => handleClickRadioBiopsy(event.target.value)}/>} label="CNB" labelPlacement="end"/>
                            (<TextField disabled={noduleList.biopsy.type !== 'CNB' || props.noduleClinic.normalThy} size="small" style={{width:'80px'}} defaultValue={biopsyCnbSize} value={biopsyCnbSize} inputProps={{style: { textAlign: 'center' }}} onChange={(event) => {
                            setBiopsyCnbSize(event.target.value);
                            handleBiopsyCnbChange(event);}} onBlur={(event) => {
                                handleBiopsyCnbChangeClearTimer(event);
                            }}/>) cm
                        </div>                
                    </RadioGroup>
                </TableCell>
            </TableRow>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Complications</TableCell>
            <TableCell align="left" className={classes.tableRightBorder}>
                <FormControlLabel control={<Checkbox name="no" color="primary" size='small' disabled={!noduleList.biopsy.onChecked || props.noduleClinic.normalThy}
                defaultChecked={noduleList.complications.no} checked={noduleList.complications.no}
                onChange={(event) => {
                    var _noduleList = {...noduleList};
                    _noduleList.complications.no = event.target.checked;
                    setNoduleList(_noduleList);
                    }}/>} label="No"/>
                <FormControlLabel control={<Checkbox name="ys" color="primary" size='small' disabled={!noduleList.biopsy.onChecked || props.noduleClinic.normalThy}
                defaultChecked={noduleList.complications.yes} checked={noduleList.complications.yes} onChange={(event) => { 
                    var _noduleList = {...noduleList};
                    _noduleList.complications.yes = event.target.checked;
                    if(!_noduleList.complications.yes) {
                        _noduleList.complications.intrathyroidal = false;
                        _noduleList.complications.perithyroidal = false;
                        _noduleList.complications.others = false;
                        _noduleList.complications.othersTxt = '';
                    }
                    setNoduleList(_noduleList);
                }}/>} label="Yes"/>
                <RadioGroup row aria-label="position" name="position" value={noduleList.complications.value} 
                    onChange={(event) => {
                        var _noduleList = {...noduleList};
                        _noduleList.complications.value = event.target.value;
                        if(!_noduleList.complications.yes) noduleList.complications.othersTxt = '';
                        if(!_noduleList.complications.value !== 'others') noduleList.complications.othersTxt = '';
                        setNoduleList(_noduleList);}}>
                    <div style={{marginTop:'10px'}}>
                        (&nbsp;<FormControlLabel control={<Checkbox name="intrathyroidal" color="primary" disabled ={props.noduleClinic.normalThy || !noduleList.complications.yes} 
                            defaultChecked={noduleList.complications.intrathyroidal} size='small' checked={noduleList.complications.intrathyroidal}
                            onChange={(event) => {
                                var _noduleList = {...noduleList};
                                _noduleList.complications.intrathyroidal = event.target.checked;
                                setNoduleList(_noduleList);}}/>} label="intrathyroidal hematoma"/>

                        <FormControlLabel control={<Checkbox name="perithyroidal" color="primary" 
                            disabled={props.noduleClinic.normalThy|| !noduleList.complications.yes}
                            defaultChecked={noduleList.complications.perithyroidal} size='small' checked={noduleList.complications.perithyroidal}
                            onChange={(event) => {
                                var _noduleList = {...noduleList};
                                _noduleList.complications.perithyroidal = event.target.checked;
                                setNoduleList(_noduleList);}}/>} label="perithyroidal hematoma"/>

                        <FormControlLabel control={<Checkbox name="others" color="primary" 
                            disabled={props.noduleClinic.normalThy || !noduleList.complications.yes}
                            defaultChecked={noduleList.complications.others} size='small' checked={noduleList.complications.others}
                            onChange={(event) => {
                                var _noduleList = {...noduleList};
                                _noduleList.complications.others = event.target.checked;
                                if(_noduleList.complications.others === false) _noduleList.complications.othersTxt = '';
                                setNoduleList(_noduleList);}}/>} label="others"/>
                        <TextField disabled={!noduleList.complications.others} value={complicationsOthersTxt} size="small" style={{width:'80px'}} inputProps={{style: { textAlign: 'center' }}} onChange={(event) => {
                            setComplicationsOthersTxt(event.target.value);
                            handleComplicationsOthersTxtChange(event);}} onBlur={(event)=> {
                            handleComplicationsOthersTxtChangeClearTimer(event);
                        }}/>&nbsp;)
                    </div>                
                </RadioGroup>
            </TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" colSpan={3} style={{backgroundColor:"grey", color:'white'}}>Note</TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Recommendation</TableCell>
              <TableCell align="left" className={classes.tableRightBorder}>
                  <TextField id="outlined-multiline-static" multiline rows={4} variant="outlined" disabled={props.noduleClinic.normalThy} style={{width:'100%'}} defaultValue={saveNote} value={saveNote} onChange={(event) => { 
                        setSaveNote(event.target.value);
                        handleNoteInputChange(event);}} onBlur={(event) => {
                        handleNoteInputChangeClearTimer(event);
                      }}/>
              </TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Reset</TableCell>
              <TableCell align="center" className={classes.tableRightBorder}>
                <Button variant="contained" style={{backgroundColor:'#C71585', float:'center', color:'white'}} startIcon={<DeleteIcon />} onClick={(event)=>{
                      var _noduleList = {...noduleList};
                      var _diameterValue = {...diameterValue};
                      var _diameterValue1 = {...diameterValue1};
                      var _diameterValue2 = {...diameterValue2};
                      var _maximalsizeValue = {...maximalSizeValue};
                      var _saveComment = {...saveComment};
                      var _saveNote = {...saveNote};
                      
                      _saveComment = '';
                      _saveNote = '';
                      _maximalsizeValue = '';
                      _diameterValue = ''
                      _diameterValue1 = ''
                      _diameterValue2 = ''
                      _noduleList = noduleDefault[props.index].data[0];
                      setMaximalSizeValue(_maximalsizeValue);
                      setDiameterValue(_diameterValue);
                      setDiameterValue1(_diameterValue1);
                      setDiameterValue2(_diameterValue2);
                      setSaveComment(_saveComment);
                      setSaveNote(_saveNote);
                      setNoduleList(_noduleList);
                      console.log(noduleDefault[props.index].data[0], noduleList);
                    }} >Reset this nodule</Button>
              </TableCell>
        </TableBody>
        {/* <TableBody>
            <TableCell align="center" className={classes.tableRightBorder} style={normalMenuStyle}>Recommendation</TableCell>
              <TableCell align="left" className={classes.tableRightBorder}>
                  <TextField id="outlined-multiline-static" multiline rows={2} variant="outlined" disabled={props.noduleClinic.normalThy} style={{width:'100%'}} defaultValue={noduleRecommendation} value={noduleRecommendation} />
                  <Button variant="contained" color='primary' startIcon={<AddIcon />} onClick={(event)=>{
                      var _noduleList = {...noduleList};
                      _noduleList.recommendation = noduleRecommendation + " for " + noduleList.location.type;
                      setNoduleList(_noduleList);
                      setNoduleRecommendation(_noduleList.recommendation);
                    }} style={{marginTop:'10px', float:'right', color:'white'}} disabled={noduleList.recommendation === noduleRecommendation || !noduleRecommendation || props.noduleClinic.normalThy}>판독문에 추가</Button>
              </TableCell>
        </TableBody> */}
      </Table>
    </TableContainer>    
}
    </div>
  );
}